import { useEffect } from "react";
import Navbar from "../components/Navbar";
import SeccionContactenos from "../components/Contactenos/SeccionContactenos";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";

export function Contactenos() {
  const { t } = useTranslation();
  const pathByLang = t("seo.contact.pathByLang", { returnObjects: true });

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
  }, []);

  return (
    <div>
      <Seo pageKey="contact" pathByLang={pathByLang} />
      <Navbar />
      <SeccionContactenos />
    </div>
  );
}
